import React from 'react'
import { PortableText } from '@portabletext/react'
import clientConfig from '../../client-config'
import styled from '@emotion/styled'

const Paragraph = styled(`p`)({
  margin: `0 0 1rem 0`,
  textTransform: 'none'
})

const Link = styled(`a`)({
}, ({ textDecoration }) => ({
  textDecoration
}))

const components = (textDecoration) => ({
  block: {
    normal: ({children}) => <Paragraph>{children}</Paragraph>
  },
  types: {
  },
  marks: {
    annotationLinkExternal: ({ text, value }) => {
      return <Link textDecoration={textDecoration} href={value?.url} target="_blank">{text}</Link>
    },
    annotationLinkEmail: ({ text, value }) => {
      return <Link textDecoration={textDecoration} href={`mailto:${value?.email}`}>{text}</Link>
    }
  }
})

const Body = ({ value, textDecoration = 'none' }) => {
  return <PortableText
    value={value}
    components={components(textDecoration)}
    onMissingComponent={false}
    {...clientConfig.sanity}
  />
};

export default Body
